import { useMemo } from 'react';

import { FEATURE_LIMITS } from 'src/data/featureLimits';
import {
  getCustomerPlan,
  getCustomerTier,
  getPlanAndTierForNextLimit,
  shouldUpgradeToBusiness,
  SUBSCRIPTION_PLAN,
} from 'src/data/subscription';
import { formatCheckoutLink } from 'src/lib/routing';
import { ROUTES } from 'src/routes';
import { useCurrentCustomer } from 'src/store';

export const useUpgradeSubscriptionInfo = ({ feature }) => {
  const customer = useCurrentCustomer();

  const currentPlan = getCustomerPlan(customer);
  const currentTier = getCustomerTier(customer);
  const { plan: nextPlan, tier: nextTier } = getPlanAndTierForNextLimit(
    currentPlan,
    currentTier,
    feature
  );

  const checkoutUrl = useMemo(() => {
    const rowsFeatureLimited = feature === FEATURE_LIMITS.resourcesRowsPerCustomer;

    if (
      (rowsFeatureLimited && shouldUpgradeToBusiness(currentPlan)) ||
      nextPlan === SUBSCRIPTION_PLAN.business
    ) {
      return ROUTES.UPGRADE;
    }

    const params = {
      plan: nextPlan,
    };
    if (nextTier) {
      params.tier = nextTier;
    }
    return formatCheckoutLink(params);
  }, [currentPlan, nextPlan, nextTier, feature]);

  return {
    nextPlan,
    nextTier,
    checkoutUrl,
  };
};
